<template>
    <iframe :srcdoc="my_html"></iframe>
</template>

<script>
    export default {
       created() {
        this.my_html = "http://essentialsdata.ssaservices.info/";
        }, 
        data() {
    return {
      my_html: ""
    };
  },
    }
</script>

<style lang="scss" scoped>

</style>